import classNames from "classnames";
import PropTypes from "prop-types";

export const SEGMENTED_VARIANTS = {
  WRAP: "wrap",
  NARROW: "narrow",
};

const Segmented = ({ options, value, variant, onChange }) => (
  <div
    className={classNames("onboarding__segmented", {
      [`onboarding__segmented--${variant}`]: variant,
    })}
  >
    {options.map((option) => (
      <button
        key={String(option.value)}
        type="button"
        aria-pressed={value === option.value}
        className={classNames("onboarding__segment", {
          "onboarding__segment--on": value === option.value,
        })}
        onClick={() => onChange(option.value)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

Segmented.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      label: PropTypes.string,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  variant: PropTypes.oneOf(Object.values(SEGMENTED_VARIANTS)),
  onChange: PropTypes.func.isRequired,
};

Segmented.defaultProps = {
  value: null,
  variant: null,
};

export default Segmented;
